module.exports = __webpack_public_path__ + "img/6.8d6cc722.jpg";